/**
 * Recalculate stock-out detail amounts for a cart item.
 *
 * @param {Object} item Stock-out detail-shaped cart item.
 * @returns {Object} Calculated stock-out detail amounts.
 */
export const calculateCartItemAmounts = item => {
  const quantity = Number(item.quantity || 0)
  const unitPrice = Number(item.unit_price || 0)
  const amount = quantity * unitPrice
  const discountRate = Number(item.discount_rate || 0)
  const discountAmount =
    item.discount_type === '%' ? amount * (discountRate / 100) : discountRate
  const totalAfterDiscount = quantity * unitPrice - discountAmount
  // Retail VAT is calculated once on the invoice total, not per item.
  const vatAmount = 0

  return {
    stock_out_quantity: quantity,
    discount_amount: discountAmount,
    total_after_discount: totalAfterDiscount,
    vat_amount: vatAmount,
    grand_total: totalAfterDiscount + vatAmount
  }
}

/**
 * Create a stock-out detail-shaped cart item from a retail product.
 *
 * @param {Object} product Product prepared for the retail-sale UI.
 * @param {number} quantity Starting quantity in the product's selling unit.
 * @returns {Object} Cart item ready for a stock-out save payload.
 */
export const createCartItem = (product, quantity = 1) => {
  const item = {
    product_id: product.id,
    uom_id: product.uom_id,
    uom_name_en: product.unit,
    uom_name_kh: product.unitKh,
    name: product.name,
    nameKh: product.nameKh,
    nameKey: product.nameKey,
    image: product.image || null,
    unit_price: Number(product.price || 0),
    quantity,
    discount_type: '%',
    discount_rate: product.promotion
      ? Number(product.promotion.discount_rate || 0)
      : 0,
    discount_amount: 0,
    total_after_discount: 0,
    vat_rate: 0,
    vat_amount: 0,
    grand_total: 0,
    stock_out_quantity: quantity,
    remarks: null,
    display_order: null,
    pro_sale_code_id: product.pro_sale_code_id,
    promotion: product.promotion || null,
    promo_type_id: product.promotion ? product.promotion.promo_type_id : null,
    ref_promo_product_id: null,
    is_free_promotion_item: false
  }

  return {
    ...item,
    ...calculateCartItemAmounts(item)
  }
}
